document.addEventListener('DOMContentLoaded', function() {
  function initializeValidation() {
    const broderieInputs = document.querySelectorAll('[data-broderie="text"]');
    const submitButton = document.querySelector('button[name="add"]');
    const form = document.querySelector('product-embroidery-form form');

    let globalHasInvalidChars = false;
    let timeout;

    function checkSpecialCharacters() {
      let hasInvalidChars = false;
      broderieInputs.forEach(input => {
        const value = input.value;
        const allowedPattern = /^[a-zA-ZÀ-ÿ0-9\s.,;:!?'"()&@#%€$£*+\/_°-]*$/;
        if (!allowedPattern.test(value) && value !== '') {
          hasInvalidChars = true;
          // Délai avant d'afficher le message sur mobile
          clearTimeout(timeout);
          timeout = setTimeout(() => {
            showError(input);
          }, 300); // 300ms de délai
        } else {
          const errorDiv = input.parentElement.querySelector('.broderie-error');
          if (errorDiv) {
            errorDiv.remove();
          }
        }
      });
      globalHasInvalidChars = hasInvalidChars;
      return hasInvalidChars;
    }

    function showError(input) {
      let errorDiv = input.parentElement.querySelector('.broderie-error');
      if (!errorDiv) {
        errorDiv = document.createElement('div');
        errorDiv.className = 'broderie-error text-red-500 text-sm mt-2';
        input.parentElement.appendChild(errorDiv);
      }
      errorDiv.textContent = 'Les caractères spéciaux ne sont pas autorisés.';
    }

    function updateButtonState() {
      if (submitButton) {
        submitButton.disabled = globalHasInvalidChars;
        if (globalHasInvalidChars) {
          submitButton.classList.add('opacity-50', 'cursor-not-allowed');
        } else {
          submitButton.classList.remove('opacity-50', 'cursor-not-allowed');
        }
      }
    }

    // Event listeners
    broderieInputs.forEach(input => {
      input.addEventListener('input', () => {
        checkSpecialCharacters();
        updateButtonState();
      }, { passive: true }); // Optimisation pour mobile
    });

    if (form) {
      form.addEventListener('change', () => {
        updateButtonState();
      }, { passive: true });
    }

    document.addEventListener('click', () => {
      updateButtonState();
    }, { passive: true });

    // Initial check
    checkSpecialCharacters();
    updateButtonState();
  }

  // Observer for dynamic fields
  const observer = new MutationObserver(() => {
    initializeValidation();
  });

  const container = document.querySelector('product-embroidery');
  if (container) {
    observer.observe(container, {
      childList: true,
      subtree: true
    });
  }

  initializeValidation();
});


/* ====================================================================== */
/* BC — Broderie multiple selon la taille "Lot de 2"                      */
/* Affiche le choix "1 / 2 broderies" UNIQUEMENT quand une taille         */
/* contenant "Lot de 2" est sélectionnée. Sur les autres tailles, force   */
/* 1 broderie et masque le choix. N'affecte PAS les produits dont aucune  */
/* taille ne contient "Lot de 2" (ex. serviettes de table).              */
/* ====================================================================== */
(function () {
  function isLot2(v) { return /lot\s*de\s*2/i.test(v || ''); }

  function sizeOf(productId) {
    var radios = document.querySelectorAll('input[name="' + productId + '-taille"], input[name="' + productId + '-size"]');
    for (var i = 0; i < radios.length; i++) { if (radios[i].checked) return radios[i].value; }
    return '';
  }

  function hasLot2Size(productId) {
    var radios = document.querySelectorAll('input[name="' + productId + '-taille"], input[name="' + productId + '-size"]');
    return Array.prototype.some.call(radios, function (r) { return isLot2(r.value); });
  }

  function applyAll() {
    document.querySelectorAll('product-embroidery').forEach(function (emb) {
      var productId = emb.getAttribute('data-product');
      if (!productId) return;
      var fieldset = document.getElementById(emb.id + '--broderie-variant');
      if (!fieldset) return;
      var radios = fieldset.querySelectorAll('input[name="broderie-variant"]');
      var hasMulti = Array.prototype.some.call(radios, function (r) {
        return (parseInt(r.getAttribute('data-max-text-inputs'), 10) || 1) > 1;
      });
      if (!hasMulti) return;               // produit à 1 broderie : ne rien faire
      if (!hasLot2Size(productId)) return; // ex. serviettes de table : laisser le choix 1/2 visible

      var wrapper = fieldset.parentElement;
      var lot2 = isLot2(sizeOf(productId));
      if (wrapper) wrapper.style.display = lot2 ? '' : 'none';

      var input1 = emb.querySelector('input[name="broderie-text-1"]');
      if (input1) input1.placeholder = lot2 ? 'E.L.' : 'Votre texte à broder ici';
      emb.querySelectorAll('.product-embroidery__image-text-input-container legend').forEach(function (l) {
        l.style.display = lot2 ? '' : 'none';
      });

      if (!lot2) {
        var single = fieldset.querySelector('input[name="broderie-variant"][data-max-text-inputs="1"]');
        if (single && !single.checked) {
          single.checked = true;
          single.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; applyAll(); }, 60);
  }

  function init() {
    applyAll();
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.name && /-(taille|size)$/.test(t.name)) { schedule(); }
    });
    var mo = new MutationObserver(function () { schedule(); });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* ====================================================================== */
/* BC — Quantité de broderies = quantité de produits (06/10/2026)         */
/*                                                                        */
/* Bug corrigé : dans aptc-bundle.js, product-embroidery.getLineItem()    */
/* renvoie toujours quantity: 1. Avec 2 serviettes + broderie, le panier  */
/* contenait 2 serviettes et 1 seule broderie (une serviette partait non  */
/* brodée, et le client ne payait qu'une broderie).                       */
/* Le cart-drawer fusionne la ligne produit et sa ligne Broderie et       */
/* pilote leurs quantités ensemble (data-keys) : il attend donc des       */
/* quantités identiques, ce que ce correctif garantit à l'ajout.          */
/*                                                                        */
/* En plus :                                                              */
/*  - le prix du bouton "Ajouter au panier" = quantité × (produit +       */
/*    broderie), recalculé à chaque changement de quantité, de variante,  */
/*    d'ajout ou de suppression de broderie (avant : prix unitaire +      */
/*    broderie, jamais multiplié, et prix figé après suppression) ;       */
/*  - une mention claire quand la quantité > 1 ("même broderie sur        */
/*    chaque exemplaire, sinon ajouter séparément") ;                     */
/*  - le prix total de la broderie (prix × quantité) dans le récap.       */
/* Couvre la fiche produit (apt-product-form) et les bundles              */
/* (bundle-form--component-options).                                     */
/* ====================================================================== */
(function () {
  var NOTICE_CLASS = 'bc-broderie-qty-notice';

  function money(cents) {
    try {
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + '€';
    }
  }

  // Écritures DOM uniquement si la valeur change (sinon le MutationObserver boucle)
  function setHtml(el, html) { if (el && el.innerHTML !== html) el.innerHTML = html; }
  function setText(el, text) { if (el && el.textContent !== text) el.textContent = text; }
  function setDisplay(el, value) { if (el && el.style.display !== value) el.style.display = value; }

  function productForm(emb) {
    var host = document.querySelector('apt-product-form[data-product="' + emb.productId + '"]')
      || document.querySelector('apt-product-form[data-product-embroidery-id="' + emb.id + '"]');
    return host ? host.querySelector('form') : null;
  }

  // Quantité du produit auquel la broderie est rattachée.
  // apt-product-form construit son corps de requête en parcourant FormData et en
  // gardant la DERNIÈRE valeur de chaque champ : on reproduit exactement cela
  // (les inputs désactivés sont ignorés par FormData, comme à l'envoi).
  function productQuantity(emb) {
    var bundleOpt = emb.closest && emb.closest('bundle-form--component-options');
    if (bundleOpt) return parseInt(bundleOpt.quantity, 10) || 1;

    var form = productForm(emb);
    if (!form) return 1;
    var qty = 1;
    try {
      new FormData(form).forEach(function (value, key) {
        if (key === 'quantity') qty = parseInt(value, 10) || 1;
      });
    } catch (e) { /* ignore */ }
    return Math.max(1, qty);
  }

  function unitLabel(emb, qty) {
    var type = (emb.getAttribute('data-bc-unit') || '').trim();
    if (type) return type;
    var title = document.querySelector('h1');
    var t = title ? title.textContent.toLowerCase() : '';
    if (/peignoir/.test(t)) return qty > 1 ? 'peignoirs' : 'peignoir';
    if (/taie/.test(t)) return qty > 1 ? 'taies' : 'taie';
    if (/serviette|drap de bain|drap de douche|fouta/.test(t)) return qty > 1 ? 'serviettes' : 'serviette';
    return qty > 1 ? 'exemplaires' : 'exemplaire';
  }

  // Prix du bouton "Ajouter au panier" : quantité × (produit + broderie)
  function refreshButtonPrice(emb) {
    var form = productForm(emb);
    var priceEl = form && form.querySelector('.product-form__current-price');
    if (!priceEl) return;
    var unit = parseInt(priceEl.dataset.price, 10);
    if (!unit) return;
    var embPrice = (emb.completed && emb.price > 0) ? emb.price : 0;
    var qty = productQuantity(emb);
    setText(priceEl, money(qty * (unit + embPrice)));
  }

  function refreshNotice(emb) {
    var qty = productQuantity(emb);
    var unit = unitLabel(emb, qty);

    // 1) Mention dans le tiroir "Ajouter une broderie"
    var drawer = document.getElementById(emb.id + '--drawer');
    if (drawer) {
      var form = drawer.querySelector('product-embroidery-form form');
      var notice = drawer.querySelector('.' + NOTICE_CLASS);
      if (form && !notice) {
        notice = document.createElement('div');
        notice.className = NOTICE_CLASS + ' typo-body tw-rounded tw-p-3 tw-bg-[#F8F5F2] tw-text-black';
        notice.setAttribute('role', 'note');
        notice.style.display = 'none';
        form.insertBefore(notice, form.firstChild);
      }
      if (notice) {
        if (qty > 1) {
          setHtml(notice,
            '<strong>Vous ajoutez ' + qty + ' ' + unit + ' :</strong> la même broderie sera réalisée sur chacune d’elles ' +
            '(' + qty + ' broderies facturées). ' +
            'Pour des textes différents, ajoutez chaque ' + unitLabel(emb, 1) + ' au panier séparément avec sa propre broderie.');
          setDisplay(notice, '');
        } else {
          setDisplay(notice, 'none');
        }
      }
    }

    // 2) Récapitulatif "Votre broderie" : prix × quantité + mention
    if (emb.completed) {
      var items = emb.querySelector('.product-embroidery__summary-items');
      if (items) {
        var line = items.querySelector('.' + NOTICE_CLASS);
        if (!line) {
          line = document.createElement('div');
          line.className = NOTICE_CLASS + ' ' + (emb.summaryItemClass || '');
          line.style.display = 'none';
          items.appendChild(line);
        }
        if (qty > 1) {
          setHtml(line, '<span class="tw-font-semibold">Broderie identique sur les ' + qty + ' ' + unit + '</span>');
          setDisplay(line, '');
        } else {
          setDisplay(line, 'none');
        }
      }
      var priceEl = emb.querySelector('.product-embroidery__summary-price');
      if (priceEl && emb.price > 0) {
        setText(priceEl, qty > 1
          ? (qty + ' × ' + money(emb.price) + ' = ' + money(emb.price * qty))
          : money(emb.price));
      }
    }

    // 3) Prix du bouton
    refreshButtonPrice(emb);
  }

  function refreshAll() {
    document.querySelectorAll('product-embroidery').forEach(function (emb) {
      try { refreshNotice(emb); } catch (e) { /* ne jamais casser la fiche produit */ }
    });
  }

  function patch() {
    var P = window.customElements.get('product-embroidery');
    if (!P) return false;
    if (P.prototype.__bcQuantityPatched) return true;

    // --- Correctif principal : la ligne Broderie suit la quantité produit ---
    var origGetLineItem = P.prototype.getLineItem;
    P.prototype.getLineItem = function () {
      var item = origGetLineItem.call(this);
      if (!item) return item;
      item.quantity = productQuantity(this);
      return item;
    };

    // --- Récapitulatif + prix bouton après ajout de broderie ---
    var origSummary = P.prototype.udapteSummary;
    if (typeof origSummary === 'function') {
      P.prototype.udapteSummary = function () {
        origSummary.apply(this, arguments);
        refreshNotice(this);
      };
    }

    // --- Prix bouton après suppression de broderie (avant : prix figé) ---
    var origReset = P.prototype.reset;
    if (typeof origReset === 'function') {
      P.prototype.reset = function () {
        origReset.apply(this, arguments);
        refreshButtonPrice(this);
      };
    }

    P.prototype.__bcQuantityPatched = true;
    return true;
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; refreshAll(); }, 80);
  }

  function init() {
    if (!patch() && window.customElements && window.customElements.whenDefined) {
      window.customElements.whenDefined('product-embroidery').then(function () { patch(); refreshAll(); });
    }
    refreshAll();

    // Quantité (saisie ou +/-), variante, ouverture du tiroir broderie
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && (t.name === 'quantity' || /-(taille|size|couleur|color)$/.test(t.name || ''))) schedule();
    });
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('apt-product-quantity-input button, quantity-input button')) schedule();
      if (t.closest('[data-action="open-x-drawer"]')) schedule();
    });
    // Re-rendu de la fiche (changement de variante) : la section est rechargée
    var mo = new MutationObserver(function () { schedule(); });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
